import { SxProps } from '@mui/material';

export const HeadingStyles: SxProps = {
  mb: 4,
  mt: 4,
};
